<template>
  <div class="container" v-loading="loading" @mouseenter="maskShow = true" @mouseleave="maskShow = false">
    <canvas :id="`myCanvas-${_uid}`" width="200" height="150" refs="myCanvas"></canvas>
    <div class="mask" v-if="maskShow">
      <span class="text-on-image el-icon-search" @click="fixButtonClick"></span>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
  name: 'regionsWrapper',
  props: {
    regions: '',
    image: ''
  },
  components: {},
  data () {
    return {
      maskShow: false,
      loading: false
    };
  },
  mounted () {
    this.loading = true;
    setTimeout(() => {
      this.drawRegions();
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapMutations(['addToDownloadImageList']),
    fixButtonClick () {
      this.$emit('fixButtonClick', {
        regions: this.regions,
        image: this.image
      });
    },
    addToDownload () {
      let target = this.$_.find(this.downloadImageList, (a) => {
        return a === this.image;
      });
      if (target) {
        return this.$message.error('该图片已经被添加');
      } else {
        this.$message.warning('添加成功');
        this.addToDownloadImageList(this.image);
      }
    },
    computedStyle (regions) {
      this.$nextTick(() => {
        let image = this.$refs.image;
        let size = {
          width: image.offsetWidth,
          height: image.offsetHeight
        };
        console.log(size);
        console.log({
          width: regions.w * size.width + 'px',
          left: regions.x * size.width + 'px',
          top: regions.y * size.height + 'px',
          height: regions.y * size.height + 'px'
        });
        return {
          width: regions.w * size.width + 'px',
          left: regions.x * size.width + 'px',
          top: regions.y * size.height + 'px',
          height: regions.y * size.height + 'px'
        };
      });
    },
    drawRegions () {
      this.$nextTick(() => {
        // let c = this.$refs['myCanvas'];
        let c = document.getElementById(`myCanvas-${this._uid}`);
        let image = new Image();
        image.src = this.image;
        let ctx = c.getContext('2d');
        let regions = this.regions;
        let max = 200;
        image.onload = function () {
          let w = image.width;
          let h = image.height;
          let persant = 200 / w;
          c.width = 200;
          c.height = h * persant;
          ctx.drawImage(image, 0, 0, w, h, 0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.lineWidth = 2;
          regions.forEach((a, idx) => {
            if (a.fixed) {
              if (a.new) {
                ctx.strokeStyle = '#E6A23C';
              } else {
                ctx.strokeStyle = '#67C23A';
              }
            } else {
              ctx.strokeStyle = '#409EFF';
            }
            ctx.beginPath();
            ctx.rect(ctx.canvas.width * a.x, ctx.canvas.height * a.y, ctx.canvas.width * a.w, ctx.canvas.height * a.h);
            ctx.stroke();
          });
        };
      });
    }
  },
  computed: {
    ...mapGetters([
      'downloadImageList'
    ])
  },
  watch: {
    regions: {
      handler () {
        this.drawRegions();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
	position: relative;
	display: inline-block;
	width: 200px;
	height: auto;

	.region-item {
		display: inline-block;
		position: absolute;
		border: 1px solid #409EFF;
	}

	.mask {
		/*visibility: hidden;*/
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 10;
		font-size: 32px;
		font-weight: 600;

		.text-on-image {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 10;
			width: 100%;
			height: 100%;
			display: -moz-box;
			text-align: center;
			display: -webkit-box;
			-webkit-box-align: center;
			-webkit-box-pack: center;
			display: -moz-box;
			-moz-box-align: center;
			-moz-box-pack: center;
			-o-box-align: center;
			-o-box-pack: center;
			-ms-box-align: center;
			-ms-box-pack: center;
			box-align: center;
			box-pack: center;
			color: $danger;
			cursor: pointer;
			background-color: rgba(255, 255, 255, 0.3);
		}
	}
}
</style>
